// import { NgModule } from '@angular/core';
import { Route } from '@angular/router';
import { AuthComponent } from '../pages/auth/auth.component';
import { authAdminGuard, authSysadminGuard } from '../shared/auth.guard';
import { EmailVerificationNoticeComponent } from '../pages/auth/email-verification-notice/email-verification-notice.component';
import { EmailVerifiedComponent } from '../pages/auth/email-verified/email-verified.component';
import { ResetPasswordComponent } from '../pages/auth/reset-password/reset-password.component';
import { ComingSoonComponent } from '../shared/widgets/coming-soon/coming-soon.component';
import { AdminComponent } from '../pages/admin/admin.component';
import { SysadminComponent } from '../pages/sysadmin/sysadmin.component';

export const APP_ROUTES: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/login',
  },
  {
    path: 'auth',
    component: AuthComponent,
    // redirectTo: '/login',
    // pathMatch: 'full',
    loadChildren: () =>
      import('../pages/auth/auth.route').then((route) => route.AUTH_ROUTES),
  },
  {
    path: 'email-notice',
    component: EmailVerificationNoticeComponent,
  },
  {
    path: 'verify_email',
    component: EmailVerifiedComponent,
  },
  {
    path: 'reset_password',
    component: ResetPasswordComponent,
  },
  {
    path: 'coming-soon',
    component: ComingSoonComponent,
    // canActivate: [authAdminGuard],
  },
  {
    path: 'admin',
    component: AdminComponent,
    loadChildren: () =>
      import('../pages/admin/admin.route').then((route) => route.ADMIN_ROUTES),
    canActivate: [authAdminGuard],
  },
  {
    path: 'system',
    component: SysadminComponent,
    loadChildren: () =>
      import('../pages/sysadmin/sysadmin.route').then(
        (route) => route.SYSADMIN_ROUTES
      ),
    canActivate: [authSysadminGuard],
  },
];

export class AppRoutingModule {}
